import React from 'react';
import { Reveal } from '../common/Reveal';
import { TESTIMONIALS } from '../../data/constants';

export function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28 px-8 md:px-16 bg-nestlent-green-pale">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <Reveal>
            <div className="text-[0.68rem] font-normal tracking-[0.35em] uppercase text-nestlent-green mb-3">Client Stories</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-[clamp(2.2rem,4vw,3.4rem)] font-light leading-[1.12] text-nestlent-charcoal mb-6">
              What Our <em className="italic text-nestlent-green">Clients</em> Say
            </h2>
          </Reveal>
          <Reveal delay={200}>
            <div className="w-12 h-px bg-nestlent-green mx-auto" />
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 150} y={30}>
              <div className="bg-white p-10 rounded-sm relative shadow-[0_4px_30px_rgba(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_50px_rgba(0,0,0,0.08)]">
                {/* Quote mark */}
                <div className="absolute top-4 right-6 font-serif text-[5rem] leading-none text-nestlent-green-pale select-none">
                  &ldquo;
                </div>
                {/* Stars */}
                <div className="text-nestlent-gold text-[0.75rem] tracking-widest mb-4">★★★★★</div>
                {/* Text */}
                <p className="text-[0.92rem] font-light leading-[1.8] text-nestlent-grey mb-7 italic">
                  {t.text}
                </p>
                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-[42px] h-[42px] rounded-full bg-nestlent-green-pale flex items-center justify-center font-serif text-[1.1rem] text-nestlent-green shrink-0">
                    {t.name[0]}
                  </div>
                  <div>
                    <div className="text-[0.88rem] font-medium text-nestlent-charcoal">{t.name}</div>
                    <div className="text-[0.72rem] text-nestlent-grey">{t.loc}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
